var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2458 13.3307C17.2696 11.4816 18.2627 9.73192 19.838 8.76341C18.8442 7.34406 17.1796 6.44415 15.4477 6.38997C13.6006 6.19608 11.8098 7.49528 10.8685 7.49528C9.90905 7.49528 8.4598 6.40922 6.89919 6.44133C4.86502 6.50705 2.96865 7.66357 1.97898 9.44198C-0.148418 13.1252 1.43843 18.5384 3.4763 21.5157C4.49589 22.9736 5.6875 24.6021 7.2467 24.5443C8.77246 24.481 9.34231 23.5714 11.184 23.5714C13.0087 23.5714 13.5433 24.5443 15.1341 24.5076C16.7714 24.481 17.8029 23.0432 18.7867 21.5715C19.5193 20.5327 20.083 19.3846 20.457 18.1698C18.5329 17.356 17.248 15.4197 17.2458 13.3307Z",
    fill: "#050505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.241 4.43197C15.1336 3.36034 15.5734 1.98294 15.4669 0.592285C14.1031 0.735528 12.8433 1.38734 11.9386 2.41786C11.0539 3.42472 10.5935 4.77788 10.6805 6.11539C12.0448 6.12943 13.386 5.49529 14.241 4.43197Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/Apple-logo.90436db37072bc2200b3e7b36d066039.svg";
export { ForwardRef as ReactComponent };